import { Button, Input, formatPhone, isValidBrazilPhone } from '@agendor/ui';
import { FormGroup, InputGroup, ErrorText, ButtonGroup } from '../shared-styles';

export type AuthScreen = 'login' | 'code' | 'name';

type Props = {
    screen: AuthScreen;
    phone: string;
    code: string;
    clientName: string;
    loginError: string | null;
    nameError: string | null;
    isLoading: boolean;
    onPhoneChange: (value: string) => void;
    onCodeChange: (value: string) => void;
    onClientNameChange: (value: string) => void;
    onRequestCode: (e: React.FormEvent) => void;
    onVerifyCode: (e: React.FormEvent) => void;
    onBackToPhone: () => void;
    onSaveName: (e: React.FormEvent) => void;
};

export default function AuthSection({
    screen,
    phone,
    code,
    clientName,
    loginError,
    nameError,
    isLoading,
    onPhoneChange,
    onCodeChange,
    onClientNameChange,
    onRequestCode,
    onVerifyCode,
    onBackToPhone,
    onSaveName,
}: Props) {
    switch (screen) {
        case 'login':
            return (
                <>
                    <h2 data-testid="screen-login">Entrar</h2>
                    <p>Digite seu número de WhatsApp para continuar.</p>
                    <form onSubmit={onRequestCode}>
                        <FormGroup>
                            <InputGroup>
                                WhatsApp
                                <Input
                                    type="tel"
                                    placeholder="(00) 00000-0000"
                                    value={phone}
                                    onChange={(e) => {
                                        onPhoneChange(formatPhone(e.target.value));
                                    }}
                                    disabled={isLoading}
                                    hasError={!!loginError}
                                    autoFocus
                                />
                                {loginError && <ErrorText>{loginError}</ErrorText>}
                            </InputGroup>
                        </FormGroup>
                        <ButtonGroup>
                            <Button
                                type="submit"
                                primary
                                disabled={isLoading || !isValidBrazilPhone(phone)}
                                data-testid="send-code-btn"
                            >
                                {isLoading ? 'Enviando...' : 'Enviar código'}
                            </Button>
                        </ButtonGroup>
                    </form>
                </>
            );

        case 'code':
            return (
                <>
                    <h2 data-testid="screen-code">Verificar código</h2>
                    <p>Digite o código de 6 dígitos enviado para {phone}.</p>
                    <form id="verify-code-form" onSubmit={onVerifyCode}>
                        <FormGroup>
                            <InputGroup>
                                Código
                                <Input
                                    type="text"
                                    inputMode="numeric"
                                    placeholder="000000"
                                    value={code}
                                    onChange={(e) => {
                                        onCodeChange(e.target.value.replace(/\D/g, '').slice(0, 6));
                                    }}
                                    disabled={isLoading}
                                    hasError={!!loginError}
                                    autoFocus
                                />
                                {loginError && <ErrorText>{loginError}</ErrorText>}
                            </InputGroup>
                        </FormGroup>
                    </form>
                    <ButtonGroup>
                        <Button type="button" onClick={onBackToPhone} disabled={isLoading} data-testid="back-btn">
                            Voltar
                        </Button>
                        <Button
                            type="submit"
                            form="verify-code-form"
                            primary
                            disabled={isLoading || code.length < 6}
                            data-testid="verify-btn"
                        >
                            {isLoading ? 'Verificando...' : 'Verificar'}
                        </Button>
                    </ButtonGroup>
                </>
            );

        case 'name':
            return (
                <>
                    <h2 data-testid="screen-name">Seu nome</h2>
                    <p>Como você gostaria de ser chamado?</p>
                    <form onSubmit={onSaveName}>
                        <FormGroup>
                            <InputGroup>
                                Nome
                                <Input
                                    type="text"
                                    placeholder="Seu nome"
                                    value={clientName}
                                    onChange={(e) => onClientNameChange(e.target.value)}
                                    hasError={!!nameError}
                                    autoFocus
                                />
                                {nameError && <ErrorText>{nameError}</ErrorText>}
                            </InputGroup>
                        </FormGroup>
                        <ButtonGroup>
                            <Button
                                type="submit"
                                primary
                                disabled={!clientName.trim() || isLoading}
                                data-testid="continue-btn"
                            >
                                {isLoading ? 'Salvando...' : 'Continuar'}
                            </Button>
                        </ButtonGroup>
                    </form>
                </>
            );
    }
}
